import { Plugins } from '@capacitor/core'

const { LocalNotifications } = Plugins

const pushNotification = async options => {
  LocalNotifications.schedule({
    notifications: [
      {
        title: 'Title',
        body: 'Body',
        id: 1,
        schedule: { at: new Date() },
        sound: null,
        attachments: null,
        actionTypeId: '',
        extra: null,
        ...options
      }
    ]
  })
}

export default pushNotification
